// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 Thème ShemsPaie - Palette */
:root {
  --color-beige: #f5f5db;
  --color-dark-brown: #6d4e36;
  --color-light-brown: #8b5e3c;
  --color-white: #ffffff;
  --color-red: #dc3545;
}
/* App.css ou index.css */


/* ✅ Body */
body {
  background-color: var(--color-white);
  padding-top: 70px;
  font-family: 'Segoe UI', sans-serif;
  color: var(--color-dark-brown);
  padding-bottom: 80px; /* espace en bas */

}

/* ✅ Navbar */
.navbar {
  background-color: var(--color-beige) !important;
  border-bottom: 2px solid var(--color-dark-brown);
}

.navbar-brand,
.navbar-text,
.navbar-nav .nav-link {
  color: var(--color-dark-brown) !important;
  font-weight: bold;
}

.navbar .btn-danger {
  background-color: var(--color-red);
  border: none;
}
.navbar .btn-danger:hover {
  background-color: var(--color-dark-brown);
  color: white;
}

/* ✅ Boutons */
.btn-success,
.btn-primary,
.btn-info {
  background-color: var(--color-light-brown);
  border: none;
  color: white;

}
.btn-success:hover,
.btn-primary:hover,
.btn-info:hover {
  background-color: var(--color-dark-brown);
  color: white;
}

/* ✅ Table */
/* ✅ Table avec bordure complète marron foncé */
.table-container {
  border: 2px solid #6d4e36; /* 🟫 Bordure foncée */
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  margin-top: 20px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.table {
  margin-bottom: 0;
  background-color: #ffffff;
  border: none;
}

.table thead th {
  background-color: rgb(245, 245, 219); /* 🟨 Beige */
  color: #6d4e36; /* Texte marron */
  border-bottom: 2px solid #6d4e36;
  text-align: center;
  font-weight: bold;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #ddd;
}

.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}

.table tbody td {
  background-color: #ffffff;
  color: #333;
  vertical-align: middle;
}


/* ✅ Forms */
.form-control,
.form-select {
  border: 1px solid var(--color-dark-brown);
}

/* ✅ Pagination */
.page-link {
  color: var(--color-dark-brown);
}
.page-link:hover {
  background-color: var(--color-light-brown);
  color: white;
}

/* ✅ Modals */
.modal-header {
  background-color: var(--color-beige);
  border-bottom: 1px solid var(--color-dark-brown);
}
.modal-title {
  color: var(--color-dark-brown);
}
/* ✅ Bordures personnalisées */
.table-bordered th,
.table-bordered td {
border: 1px solid #8b5e3c;
}

/* 🎨 Alternance de lignes avec fond rosé très clair */
.table-striped > tbody > tr:nth-of-type(odd) > * {
background-color: rgb(254, 246, 241); /* rose pâle */
}

/* 🧭 Centrage vertical et horizontal du texte */
.table th,
.table td {
text-align: center;
vertical-align: middle !important;
}

/* 💄 Optionnel : améliorer la lisibilité */
.table thead th {
font-weight: bold;
font-size: 16px;
color: #6d4e36;
}
/* 🎯 Pagination active color (ShemsPaie - Marron & Beige) */
.page-item.active .page-link,
.page-link.active {
z-index: 3;
color: white; /* Texte blanc pour contraste */
background-color: #8b5e3c; /* Marron plus clair */
border-color: #6d4e36; /* Marron foncé */
}

/* 💅 Pagination hover */
.page-link:hover {
background-color: #f5f5db;
color: #6d4e36;
border-color: #6d4e36;
}

/* 🧼 Pagination spacing and radius */
.page-link {
border-radius: 0.375rem;
padding: 0.375rem 0.75rem;
}
.card:hover {
transform: scale(1.03);
transition: 0.2s ease-in-out;
}
.btn-home-toggle {
background-color: transparent;
border: 1px solid #6d4e36; /* Marron foncé */
color: #6d4e36;
border-radius: 6px;
padding: 6px 10px;
transition: all 0.3s ease;
}

.btn-home-toggle:hover {
background-color: #6d4e36;
color: #ffffff;
}
.login-container {
height: 92vh;
display: flex;
justify-content: center;
align-items: center;
background-color: #f8f9fa;
}

.login-card {
width: 420px;
padding: 30px;
border-radius: 20px;
background-color: #f5f5db;
border: 2px solid #8b5e3c;
margin-top: -60px;
box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.btn-marron {
background-color: #8b5e3c;
border-color: #8b5e3c;
color: white;
}

.btn-marron:hover {
background-color: #6d4e36;
border-color: #6d4e36;
color: white;
}

/* Centrer et aligner sur la même ligne pagination + lignes par page */
.react-bootstrap-table-pagination {
display: flex !important;
justify-content: center;
align-items: center;
flex-wrap: nowrap !important;
gap: 2rem;
margin-top: 20px;
}

/* Garde le sélecteur lignes par page aligné */
.react-bootstrap-table-pagination .sizePerPage-dropdown {
display: flex;
align-items: center;
gap: 0.5rem;
font-weight: bold;
color: #6d4e36;
white-space: nowrap;
}

/* Dropdown style */
.react-bootstrap-table-pagination .dropdown-toggle {
background-color: #f5f5db;
color: #6d4e36;
border: 1px solid #6d4e36;
font-weight: bold;
padding: 4px 12px;
}

/* Pagination links */
.pagination {
margin: 0;
}

.pagination .page-link {
color: #6d4e36;
border-color: #6d4e36;
}

.pagination .page-item.active .page-link {
background-color: #8b5e3c;
color: white;
border-color: #8b5e3c;
}

.pagination .page-link:hover {
background-color: #8b5e3c;
color: white;
border-color: #6d4e36;
}
.react-bootstrap-table-pagination {
display: flex !important;
justify-content: center;
align-items: center;
flex-wrap: nowrap !important;
gap: 1rem; /* 🔄 Réduit l'espace entre les éléments */
margin-top: 20px;
}

.react-bootstrap-table-pagination .sizePerPage-dropdown {
display: flex;
align-items: center;
gap: 0.5rem;
font-weight: bold;
color: #6d4e36;
white-space: nowrap;
margin-right: 0.5rem; /* 🧲 Rapproche du centre */
}
.sticky-col {
position: sticky;
z-index: 1;
background: rgb(237, 237, 198);
}

.left-0 {
left: 0;
z-index: 2; /* au-dessus de .left-150 */
}

.left-150 {
left: 100px;
}
/* ============================
   ⛽ Pointage Matériel (Journalier)
   ============================ */

/* Bloc résumé "Déjà pointés" */
.pm-summary-card {
  border: 2px solid var(--color-dark-brown);
  border-radius: 10px;
  background: var(--color-beige);
}

.pm-summary-card .badge {
  font-size: 0.9rem;
  padding: 6px 10px;
}

/* Lignes déjà pointées (table) */
.pm-row-disabled {
  background-color: #f1f1f1 !important;
  opacity: 0.95;
}

.pm-row-disabled td {
  background-color: #f1f1f1 !important;
}

/* Inputs désactivés bien lisibles */
.pm-row-disabled input,
.pm-row-disabled textarea,
.pm-row-disabled select {
  background-color: #e9ecef !important;
  cursor: not-allowed !important;
  border-color: #c8c8c8 !important;
  color: #6c757d !important;
}

/* Etiquette "Déjà pointé" */
.pm-badge-present {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  color: var(--color-red);
}

.pm-badge-ok {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  color: #198754; /* vert bootstrap */
}

/* Select (react-select) – cohérent avec thème */
.pm-react-select .react-select__control {
  border: 1px solid var(--color-dark-brown) !important;
  box-shadow: none !important;
}

.pm-react-select .react-select__control:hover {
  border-color: var(--color-light-brown) !important;
}

.pm-react-select .react-select__multi-value {
  background-color: rgb(245, 245, 219) !important;
  border: 1px solid var(--color-dark-brown);
}

.pm-react-select .react-select__multi-value__label {
  color: var(--color-dark-brown) !important;
  font-weight: bold;
}

/* Bouton "Vérifier" */
.pm-btn-check {
  background-color: var(--color-light-brown) !important;
  border: none !important;
  color: white !important;
}
.pm-btn-check:hover {
  background-color: var(--color-dark-brown) !important;
}

/* Table container spécial matériel (si besoin) */
.pm-table-container {
  border: 2px solid var(--color-dark-brown);
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

/* Sticky colonnes optionnelles (Matricule + Type) */
.pm-sticky {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: rgb(245, 245, 219) !important;
  border-right: 1px solid #8b5e3c;
}

.pm-sticky-2 {
  position: sticky;
  left: 120px; /* ajuste selon largeur de la 1ère colonne */
  z-index: 2;
  background-color: rgb(245, 245, 219) !important;
  border-right: 1px solid #8b5e3c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;AACtB;AACA,yBAAyB;;;AAGzB,WAAW;AACX;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mCAAmC;EACnC,8BAA8B;EAC9B,oBAAoB,EAAE,kBAAkB;;AAE1C;;AAEA,aAAa;AACb;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;;;EAGE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA,cAAc;AACd;;;EAGE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;;AAEd;AACA;;;EAGE,yCAAyC;EACzC,YAAY;AACd;;AAEA,YAAY;AACZ,+CAA+C;AAC/C;EACE,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC,EAAE,aAAa;EACnD,cAAc,EAAE,iBAAiB;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;;AAGA,YAAY;AACZ;;EAEE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;AAChC;AACA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,gDAAgD;AAClD;AACA;EACE,8BAA8B;AAChC;AACA,8BAA8B;AAC9B;;AAEA,yBAAyB;AACzB;;AAEA,sDAAsD;AACtD;AACA,oCAAoC,EAAE,cAAc;AACpD;;AAEA,gDAAgD;AAChD;;AAEA,kBAAkB;AAClB,iCAAiC;AACjC;;AAEA,2CAA2C;AAC3C;AACA,iBAAiB;AACjB,eAAe;AACf,cAAc;AACd;AACA,4DAA4D;AAC5D;;AAEA,UAAU;AACV,YAAY,EAAE,+BAA+B;AAC7C,yBAAyB,EAAE,sBAAsB;AACjD,qBAAqB,EAAE,iBAAiB;AACxC;;AAEA,wBAAwB;AACxB;AACA,yBAAyB;AACzB,cAAc;AACd,qBAAqB;AACrB;;AAEA,qCAAqC;AACrC;AACA,uBAAuB;AACvB,yBAAyB;AACzB;AACA;AACA,sBAAsB;AACtB,4BAA4B;AAC5B;AACA;AACA,6BAA6B;AAC7B,yBAAyB,EAAE,iBAAiB;AAC5C,cAAc;AACd,kBAAkB;AAClB,iBAAiB;AACjB,yBAAyB;AACzB;;AAEA;AACA,yBAAyB;AACzB,cAAc;AACd;AACA;AACA,YAAY;AACZ,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;AACA,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB,yBAAyB;AACzB,yBAAyB;AACzB,iBAAiB;AACjB,yCAAyC;AACzC;;AAEA;AACA,yBAAyB;AACzB,qBAAqB;AACrB,YAAY;AACZ;;AAEA;AACA,yBAAyB;AACzB,qBAAqB;AACrB,YAAY;AACZ;;AAEA,sEAAsE;AACtE;AACA,wBAAwB;AACxB,uBAAuB;AACvB,mBAAmB;AACnB,4BAA4B;AAC5B,SAAS;AACT,gBAAgB;AAChB;;AAEA,8CAA8C;AAC9C;AACA,aAAa;AACb,mBAAmB;AACnB,WAAW;AACX,iBAAiB;AACjB,cAAc;AACd,mBAAmB;AACnB;;AAEA,mBAAmB;AACnB;AACA,yBAAyB;AACzB,cAAc;AACd,yBAAyB;AACzB,iBAAiB;AACjB,iBAAiB;AACjB;;AAEA,qBAAqB;AACrB;AACA,SAAS;AACT;;AAEA;AACA,cAAc;AACd,qBAAqB;AACrB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,qBAAqB;AACrB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,qBAAqB;AACrB;AACA;AACA,wBAAwB;AACxB,uBAAuB;AACvB,mBAAmB;AACnB,4BAA4B;AAC5B,SAAS,EAAE,0CAA0C;AACrD,gBAAgB;AAChB;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,WAAW;AACX,iBAAiB;AACjB,cAAc;AACd,mBAAmB;AACnB,oBAAoB,EAAE,2BAA2B;AACjD;AACA;AACA,gBAAgB;AAChB,UAAU;AACV,8BAA8B;AAC9B;;AAEA;AACA,OAAO;AACP,UAAU,EAAE,2BAA2B;AACvC;;AAEA;AACA,WAAW;AACX;AACA;;iCAEiC;;AAEjC,+BAA+B;AAC/B;EACE,yCAAyC;EACzC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oCAAoC;AACpC;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc,EAAE,mBAAmB;AACrC;;AAEA,gDAAgD;AAChD;EACE,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,oDAAoD;AACtD;;AAEA,iDAAiD;AACjD;EACE,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,+CAA+C;EAC/C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW,EAAE,4CAA4C;EACzD,UAAU;EACV,+CAA+C;EAC/C,+BAA+B;AACjC","sourcesContent":["/* 🎨 Thème ShemsPaie - Palette */\r\n:root {\r\n  --color-beige: #f5f5db;\r\n  --color-dark-brown: #6d4e36;\r\n  --color-light-brown: #8b5e3c;\r\n  --color-white: #ffffff;\r\n  --color-red: #dc3545;\r\n}\r\n/* App.css ou index.css */\r\n\r\n\r\n/* ✅ Body */\r\nbody {\r\n  background-color: var(--color-white);\r\n  padding-top: 70px;\r\n  font-family: 'Segoe UI', sans-serif;\r\n  color: var(--color-dark-brown);\r\n  padding-bottom: 80px; /* espace en bas */\r\n\r\n}\r\n\r\n/* ✅ Navbar */\r\n.navbar {\r\n  background-color: var(--color-beige) !important;\r\n  border-bottom: 2px solid var(--color-dark-brown);\r\n}\r\n\r\n.navbar-brand,\r\n.navbar-text,\r\n.navbar-nav .nav-link {\r\n  color: var(--color-dark-brown) !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.navbar .btn-danger {\r\n  background-color: var(--color-red);\r\n  border: none;\r\n}\r\n.navbar .btn-danger:hover {\r\n  background-color: var(--color-dark-brown);\r\n  color: white;\r\n}\r\n\r\n/* ✅ Boutons */\r\n.btn-success,\r\n.btn-primary,\r\n.btn-info {\r\n  background-color: var(--color-light-brown);\r\n  border: none;\r\n  color: white;\r\n\r\n}\r\n.btn-success:hover,\r\n.btn-primary:hover,\r\n.btn-info:hover {\r\n  background-color: var(--color-dark-brown);\r\n  color: white;\r\n}\r\n\r\n/* ✅ Table */\r\n/* ✅ Table avec bordure complète marron foncé */\r\n.table-container {\r\n  border: 2px solid #6d4e36; /* 🟫 Bordure foncée */\r\n  border-radius: 8px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  margin-top: 20px;\r\n  background-color: white;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.table {\r\n  margin-bottom: 0;\r\n  background-color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.table thead th {\r\n  background-color: rgb(245, 245, 219); /* 🟨 Beige */\r\n  color: #6d4e36; /* Texte marron */\r\n  border-bottom: 2px solid #6d4e36;\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n.table-bordered th,\r\n.table-bordered td {\r\n  border: 1px solid #ddd;\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.table tbody td {\r\n  background-color: #ffffff;\r\n  color: #333;\r\n  vertical-align: middle;\r\n}\r\n\r\n\r\n/* ✅ Forms */\r\n.form-control,\r\n.form-select {\r\n  border: 1px solid var(--color-dark-brown);\r\n}\r\n\r\n/* ✅ Pagination */\r\n.page-link {\r\n  color: var(--color-dark-brown);\r\n}\r\n.page-link:hover {\r\n  background-color: var(--color-light-brown);\r\n  color: white;\r\n}\r\n\r\n/* ✅ Modals */\r\n.modal-header {\r\n  background-color: var(--color-beige);\r\n  border-bottom: 1px solid var(--color-dark-brown);\r\n}\r\n.modal-title {\r\n  color: var(--color-dark-brown);\r\n}\r\n/* ✅ Bordures personnalisées */\r\n.table-bordered th,\r\n.table-bordered td {\r\nborder: 1px solid #8b5e3c;\r\n}\r\n\r\n/* 🎨 Alternance de lignes avec fond rosé très clair */\r\n.table-striped > tbody > tr:nth-of-type(odd) > * {\r\nbackground-color: rgb(254, 246, 241); /* rose pâle */\r\n}\r\n\r\n/* 🧭 Centrage vertical et horizontal du texte */\r\n.table th,\r\n.table td {\r\ntext-align: center;\r\nvertical-align: middle !important;\r\n}\r\n\r\n/* 💄 Optionnel : améliorer la lisibilité */\r\n.table thead th {\r\nfont-weight: bold;\r\nfont-size: 16px;\r\ncolor: #6d4e36;\r\n}\r\n/* 🎯 Pagination active color (ShemsPaie - Marron & Beige) */\r\n.page-item.active .page-link,\r\n.page-link.active {\r\nz-index: 3;\r\ncolor: white; /* Texte blanc pour contraste */\r\nbackground-color: #8b5e3c; /* Marron plus clair */\r\nborder-color: #6d4e36; /* Marron foncé */\r\n}\r\n\r\n/* 💅 Pagination hover */\r\n.page-link:hover {\r\nbackground-color: #f5f5db;\r\ncolor: #6d4e36;\r\nborder-color: #6d4e36;\r\n}\r\n\r\n/* 🧼 Pagination spacing and radius */\r\n.page-link {\r\nborder-radius: 0.375rem;\r\npadding: 0.375rem 0.75rem;\r\n}\r\n.card:hover {\r\ntransform: scale(1.03);\r\ntransition: 0.2s ease-in-out;\r\n}\r\n.btn-home-toggle {\r\nbackground-color: transparent;\r\nborder: 1px solid #6d4e36; /* Marron foncé */\r\ncolor: #6d4e36;\r\nborder-radius: 6px;\r\npadding: 6px 10px;\r\ntransition: all 0.3s ease;\r\n}\r\n\r\n.btn-home-toggle:hover {\r\nbackground-color: #6d4e36;\r\ncolor: #ffffff;\r\n}\r\n.login-container {\r\nheight: 92vh;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nbackground-color: #f8f9fa;\r\n}\r\n\r\n.login-card {\r\nwidth: 420px;\r\npadding: 30px;\r\nborder-radius: 20px;\r\nbackground-color: #f5f5db;\r\nborder: 2px solid #8b5e3c;\r\nmargin-top: -60px;\r\nbox-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.btn-marron {\r\nbackground-color: #8b5e3c;\r\nborder-color: #8b5e3c;\r\ncolor: white;\r\n}\r\n\r\n.btn-marron:hover {\r\nbackground-color: #6d4e36;\r\nborder-color: #6d4e36;\r\ncolor: white;\r\n}\r\n\r\n/* Centrer et aligner sur la même ligne pagination + lignes par page */\r\n.react-bootstrap-table-pagination {\r\ndisplay: flex !important;\r\njustify-content: center;\r\nalign-items: center;\r\nflex-wrap: nowrap !important;\r\ngap: 2rem;\r\nmargin-top: 20px;\r\n}\r\n\r\n/* Garde le sélecteur lignes par page aligné */\r\n.react-bootstrap-table-pagination .sizePerPage-dropdown {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 0.5rem;\r\nfont-weight: bold;\r\ncolor: #6d4e36;\r\nwhite-space: nowrap;\r\n}\r\n\r\n/* Dropdown style */\r\n.react-bootstrap-table-pagination .dropdown-toggle {\r\nbackground-color: #f5f5db;\r\ncolor: #6d4e36;\r\nborder: 1px solid #6d4e36;\r\nfont-weight: bold;\r\npadding: 4px 12px;\r\n}\r\n\r\n/* Pagination links */\r\n.pagination {\r\nmargin: 0;\r\n}\r\n\r\n.pagination .page-link {\r\ncolor: #6d4e36;\r\nborder-color: #6d4e36;\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\nbackground-color: #8b5e3c;\r\ncolor: white;\r\nborder-color: #8b5e3c;\r\n}\r\n\r\n.pagination .page-link:hover {\r\nbackground-color: #8b5e3c;\r\ncolor: white;\r\nborder-color: #6d4e36;\r\n}\r\n.react-bootstrap-table-pagination {\r\ndisplay: flex !important;\r\njustify-content: center;\r\nalign-items: center;\r\nflex-wrap: nowrap !important;\r\ngap: 1rem; /* 🔄 Réduit l'espace entre les éléments */\r\nmargin-top: 20px;\r\n}\r\n\r\n.react-bootstrap-table-pagination .sizePerPage-dropdown {\r\ndisplay: flex;\r\nalign-items: center;\r\ngap: 0.5rem;\r\nfont-weight: bold;\r\ncolor: #6d4e36;\r\nwhite-space: nowrap;\r\nmargin-right: 0.5rem; /* 🧲 Rapproche du centre */\r\n}\r\n.sticky-col {\r\nposition: sticky;\r\nz-index: 1;\r\nbackground: rgb(237, 237, 198);\r\n}\r\n\r\n.left-0 {\r\nleft: 0;\r\nz-index: 2; /* au-dessus de .left-150 */\r\n}\r\n\r\n.left-150 {\r\nleft: 100px;\r\n}\r\n/* ============================\r\n   ⛽ Pointage Matériel (Journalier)\r\n   ============================ */\r\n\r\n/* Bloc résumé \"Déjà pointés\" */\r\n.pm-summary-card {\r\n  border: 2px solid var(--color-dark-brown);\r\n  border-radius: 10px;\r\n  background: var(--color-beige);\r\n}\r\n\r\n.pm-summary-card .badge {\r\n  font-size: 0.9rem;\r\n  padding: 6px 10px;\r\n}\r\n\r\n/* Lignes déjà pointées (table) */\r\n.pm-row-disabled {\r\n  background-color: #f1f1f1 !important;\r\n  opacity: 0.95;\r\n}\r\n\r\n.pm-row-disabled td {\r\n  background-color: #f1f1f1 !important;\r\n}\r\n\r\n/* Inputs désactivés bien lisibles */\r\n.pm-row-disabled input,\r\n.pm-row-disabled textarea,\r\n.pm-row-disabled select {\r\n  background-color: #e9ecef !important;\r\n  cursor: not-allowed !important;\r\n  border-color: #c8c8c8 !important;\r\n  color: #6c757d !important;\r\n}\r\n\r\n/* Etiquette \"Déjà pointé\" */\r\n.pm-badge-present {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: bold;\r\n  color: var(--color-red);\r\n}\r\n\r\n.pm-badge-ok {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: bold;\r\n  color: #198754; /* vert bootstrap */\r\n}\r\n\r\n/* Select (react-select) – cohérent avec thème */\r\n.pm-react-select .react-select__control {\r\n  border: 1px solid var(--color-dark-brown) !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.pm-react-select .react-select__control:hover {\r\n  border-color: var(--color-light-brown) !important;\r\n}\r\n\r\n.pm-react-select .react-select__multi-value {\r\n  background-color: rgb(245, 245, 219) !important;\r\n  border: 1px solid var(--color-dark-brown);\r\n}\r\n\r\n.pm-react-select .react-select__multi-value__label {\r\n  color: var(--color-dark-brown) !important;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Bouton \"Vérifier\" */\r\n.pm-btn-check {\r\n  background-color: var(--color-light-brown) !important;\r\n  border: none !important;\r\n  color: white !important;\r\n}\r\n.pm-btn-check:hover {\r\n  background-color: var(--color-dark-brown) !important;\r\n}\r\n\r\n/* Table container spécial matériel (si besoin) */\r\n.pm-table-container {\r\n  border: 2px solid var(--color-dark-brown);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: white;\r\n}\r\n\r\n/* Sticky colonnes optionnelles (Matricule + Type) */\r\n.pm-sticky {\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 2;\r\n  background-color: rgb(245, 245, 219) !important;\r\n  border-right: 1px solid #8b5e3c;\r\n}\r\n\r\n.pm-sticky-2 {\r\n  position: sticky;\r\n  left: 120px; /* ajuste selon largeur de la 1ère colonne */\r\n  z-index: 2;\r\n  background-color: rgb(245, 245, 219) !important;\r\n  border-right: 1px solid #8b5e3c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
